/* Minimal cart adapter. Shopify remains authoritative for prices and eligibility.
   The optional shopping timer does not reserve stock or alter checkout. */
(function () {
  'use strict';
  var currentCart = null;
  var busy = false;
  var mounted = false;
  var lastFocus = null;
  var pendingQuantities = new Map();
  var translations = {};
  var channel = null;
  try { if (typeof BroadcastChannel === 'function') channel = new BroadcastChannel('pickie-cart-change'); } catch (error) {}
  function cartRoot() { return document.querySelector('[data-cart]'); }
  function route(path) { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || window.theme && window.theme.routes && window.theme.routes.root || '/').replace(/\/?$/, '/') + path; }
  function readJson(scope, selector) {
    var node = scope && scope.querySelector(selector);
    return node ? JSON.parse(node.textContent) : null;
  }
  function message(key, detail) {
    var node = document.querySelector('[data-minimal-status]');
    if (!node) return;
    node.hidden = !key;
    node.textContent = detail || translations[key] || key || '';
  }
  function codes(data) {
    if (data && Array.isArray(data.discount_codes)) return data.discount_codes.filter(function (x) { return x.applicable === true; }).map(function (x) { return x.code; });
    var all = (data && data.cart_level_discount_applications || []).slice();
    (data && data.items || []).forEach(function (item) {
      (item.line_level_discount_allocations && item.line_level_discount_allocations.length ? item.line_level_discount_allocations : item.discount_allocations || []).forEach(function (x) { all.push(x.discount_application); });
    });
    return all.filter(function (x) { return x && x.type === 'discount_code'; }).map(function (x) { return x.title; }).filter(function (x, i, a) { return a.indexOf(x) === i; });
  }
  function identity(item) {
    var props = item.properties || {};
    return JSON.stringify([item.variant_id || item.id, item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || null, Object.keys(props).sort().map(function (key) { return [key, props[key]]; })]);
  }
  function fingerprint(data) {
    return JSON.stringify({ items: (data.items || []).map(function (x) { return [x.key, x.variant_id, x.quantity, x.selling_plan_allocation && x.selling_plan_allocation.selling_plan.id, x.final_line_price]; }), total: data.total_price, currency: data.currency, codes: codes(data).map(function (code) { return code.toUpperCase(); }).sort() });
  }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currentCart && currentCart.currency || 'USD' }).format(cents / 100);
  }
  function sync(data, metadata) {
    if (data) { currentCart = data; if (typeof currentCart.currency !== 'string') currentCart.currency = currentCart.currency && currentCart.currency.iso_code || 'USD'; }
    var root = cartRoot();
    if (!root || !currentCart) return;
    translations = readJson(root, '[data-minimal-translations]') || translations;
    ['crosssell', 'shipping'].forEach(function (kind) {
      var source = metadata && metadata.querySelector('template[data-minimal-' + kind + ']');
      var slot = root.querySelector('[data-minimal-' + kind + '-slot]');
      if (source && slot) slot.replaceChildren(source.content.cloneNode(true));
    });
    root.querySelectorAll('[data-minimal-count]').forEach(function (node) { node.textContent = currentCart.item_count; });
    root.querySelectorAll('[data-minimal-checkout-price]').forEach(function (node) { node.textContent = money(currentCart.total_price); });
    var footer = root.querySelector('[data-foot-holder]');
    if (footer) footer.classList.toggle('is-hidden', currentCart.item_count === 0);
    if (window.PICKIE_MINIMAL_TIMER) window.PICKIE_MINIMAL_TIMER.sync(currentCart, Boolean(window.cart && window.cart.cartDrawerIsOpen));
    var discountBox = root.querySelector('.pickie-minimal-discount');
    if (discountBox) discountBox.hidden = currentCart.item_count === 0;
    var applied = root.querySelector('[data-minimal-applied-codes]');
    if (applied) applied.replaceChildren();
    codes(currentCart).forEach(function (code) {
      var button = document.createElement('button');
      button.type = 'button'; button.dataset.minimalRemoveCode = code;
      button.textContent = code + ' ×';
      button.setAttribute('aria-label', (translations.remove || 'Remove code') + ' ' + code);
      if (applied) applied.appendChild(button);
    });
    // The native summary hides line-only discount names. Rebuild from authoritative allocations.
    var holder = root.querySelector('[data-cart-discounts-holder]');
    if (holder) {
      var total = currentCart.original_total_price - currentCart.total_price;
      holder.classList.toggle('is-hidden', total <= 0);
      holder.dataset.pickieDiscountTotal = Math.max(0, total);
      if (total > 0) {
        var row = document.createElement('p'); row.className = 'cart-discounts';
        var title = document.createElement('span'); title.className = 'cart-discounts__title';
        var value = document.createElement('span'); value.className = 'cart-discounts__price';
        var names = codes(currentCart);
        title.textContent = names.length ? names.join(', ') : 'Discount'; value.textContent = '−' + money(total);
        row.append(title, value); holder.replaceChildren(row);
      }
    }
    viewport();
  }
  window.PICKIE_MINIMAL_SYNC = function (snapshot) {
    var data = snapshot.ajaxCart || readJson(snapshot.metadata, '[data-minimal-cart-json]');
    if (data) sync(data, snapshot.metadata);
  };
  function viewport() {
    var shell = document.querySelector('.pickie-minimal-shell');
    if (!shell) return;
    var vv = window.visualViewport;
    var height = vv ? vv.height : window.innerHeight;
    shell.style.setProperty('--pickie-minimal-viewport-height', height + 'px');
    shell.style.setProperty('--pickie-minimal-viewport-top', (vv ? vv.offsetTop : 0) + 'px');
    shell.dataset.compactViewport = String(height < 500);
    if (window.cart) {
      var scroller = shell.querySelector('[data-minimal-scroll-form]') || shell.querySelector('[data-cart-scroll]');
      if (scroller && window.cart.cartScroll !== scroller) {
        window.cart.cartScroll = scroller;
        if (window.cart.cartDrawerIsOpen) {
          document.body.removeAttribute('data-drawer-closing');
          document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: scroller }));
        }
      }
    }
  }
  async function request(path, body) {
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(route(path), {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined, signal: controller.signal,
        pickieBypassProductFormHarden: true
      });
      var data = await response.json();
      if (!response.ok) {
        var error = new Error(data.description || data.message || 'Cart request failed.');
        error.confirmed = true; throw error;
      }
      return data;
    } finally { clearTimeout(timeout); }
  }
  function lock(value) {
    busy = value;
    var root = cartRoot();
    if (root) root.querySelectorAll('[data-quantity-button], [data-quantity-field], [data-pickie-cart-upsell], [data-minimal-apply], [data-minimal-remove-code], [data-minimal-code]').forEach(function (node) {
      if (value) { if (!node.disabled) { node.dataset.minimalLocked = 'true'; node.disabled = true; } }
      else if (node.dataset.minimalLocked) { node.disabled = false; delete node.dataset.minimalLocked; }
    });
    // Readiness checks inspect disabled quantity inputs synchronously. Restore
    // those inputs before repainting the payment lock and checking readiness.
    if (window.cart && window.cart.setMinimalBusy) window.cart.setMinimalBusy(value);
  }
  async function commit(path, payload, focusKey) {
    if (busy) return null;
    lock(true); message('busy');
    try {
      payload.sections = ['api-cart-items'];
      payload.sections_url = window.location.pathname;
      var data = await request(path, payload);
      var html = data.sections && data.sections['api-cart-items'];
      if (html && window.cart.build(html) === false) throw new Error('Cart render failed.');
      else if (!html && !(await window.cart.getCart())) throw new Error('Cart refresh failed.');
      if (!currentCart) throw new Error('Cart snapshot unavailable.');
      if (Number.isSafeInteger(data.item_count) && Array.isArray(data.items)) sync(data);
      if (channel) { try { channel.postMessage('changed'); } catch (error) {} }
      message('');
      return data;
    } catch (error) {
      // Never retry a POST automatically: an interrupted response may have committed.
      await window.cart.getCart();
      message('error', error.confirmed ? error.message : null);
      return null;
    } finally {
      lock(false);
      while (pendingQuantities.size) {
        var next = pendingQuantities.entries().next().value; pendingQuantities.delete(next[0]);
        var match = currentCart && currentCart.items.find(function (item) { return identity(item) === next[1].identity; });
        if (match) { window.cart.updateCart({ id: match.key, quantity: next[1].quantity }); break; }
        else message('cartChanged');
      }
      if (focusKey) {
        var inputs = Array.from(document.querySelectorAll('[data-cart] [data-quantity-field]'));
        var input = inputs.find(function (node) { return node.dataset.id === focusKey; });
        (input || document.querySelector('[data-cart-close]'))?.focus({ preventScroll: true });
      }
    }
  }
  window.PICKIE_MINIMAL_ADD = async function (button) {
    if (busy || button.disabled || window.cart.minimalIsReady && !window.cart.minimalIsReady()) return;
    var id = Number(button.dataset.variantId);
    var handle = button.dataset.targetHandle;
    if (!Number.isSafeInteger(id)) return;
    // Reconcile before additive mutations, including another tab's cart changes.
    lock(true); message('busy');
    var fresh;
    try { fresh = await request('cart.js'); }
    catch (error) { lock(false); message('error'); return; }
    lock(false);
    var present = fresh.items.some(function (item) { return item.handle === handle || (item.url || '').split('?')[0].endsWith('/' + handle); });
    if (present) { await window.cart.getCart(); message(''); return; }
    if (window.PICKIE_ALIGN_SELLING_PLAN) window.PICKIE_ALIGN_SELLING_PLAN(null);
    var data = await commit('cart/add.js', { items: [{ id: id, quantity: 1 }] });
    if (data) {
      var focus = document.querySelector('[data-cart] .cart__checkout');
      if (focus) focus.focus({ preventScroll: true });
    }
  };
  async function discount(removeCode) {
    if (busy || window.cart.minimalIsReady && !window.cart.minimalIsReady()) return;
    var input = document.querySelector('[data-minimal-code]');
    if (!input) return;
    var code = input.value.trim();
    var status = document.querySelector('[data-minimal-code-status]');
    if (!removeCode && !code) { status.textContent = translations.empty; input.focus(); return; }
    // Preserve codes applied in another tab before replacing the server's list.
    lock(true); message('busy');
    var fresh;
    try { fresh = await request('cart.js'); }
    catch (error) { lock(false); message('error'); return; }
    lock(false);
    var list = codes(fresh);
    if (removeCode) list = list.filter(function (x) { return x !== removeCode; });
    else if (!list.some(function (x) { return x.toUpperCase() === code.toUpperCase(); })) list.push(code);
    var result = await commit('cart/update.js', { discount: list.join(',') });
    if (!result) return;
    var applied = codes(currentCart).some(function (x) { return x.toUpperCase() === code.toUpperCase(); });
    var removed = removeCode && !codes(currentCart).some(function (x) { return x.toUpperCase() === removeCode.toUpperCase(); });
    status.textContent = removeCode ? (removed ? translations.removed : translations.notApplied) : applied ? translations.applied : translations.notApplied;
    status.dataset.state = (removeCode ? removed : applied) ? 'success' : 'error';
    if (applied) input.value = '';
    input.focus({ preventScroll: true });
  }
  function mount() {
    if (mounted || !window.cart || !window.cart.setMinimalBusy) return;
    mounted = true;
    var cart = window.cart;
    var nativeOpen = cart.openCartDrawer;
    var nativeClose = cart.closeCartDrawer;
    cart.openCartDrawer = function () {
      lastFocus = document.activeElement;
      if (!cart.cart) cart.renderCart();
      viewport();
      var result = nativeOpen.apply(cart, arguments);
      viewport();
      sync(currentCart || readJson(cartRoot(), '[data-minimal-cart-json]'));
      cart.getCart({ reuse: true, maxAge: 1000 });
      return result;
    };
    cart.closeCartDrawer = function () {
      nativeClose.apply(cart, arguments);
      if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
    };
    cart.updateCart = function (update) {
      var quantity = Number(update.quantity);
      if (!Number.isSafeInteger(quantity) || quantity < 0) { cart.getCart(); return; }
      if (busy) {
        var item = currentCart && currentCart.items.find(function (line) { return line.key === String(update.id); });
        if (item) pendingQuantities.set(String(update.id), { quantity: quantity, identity: identity(item) });
        return;
      }
      return commit('cart/change.js', { id: String(update.id), quantity: quantity }, String(update.id));
    };
    if (cartRoot()) sync(readJson(cartRoot(), '[data-minimal-cart-json]'));
    document.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-minimal-apply], [data-minimal-remove-code]');
      if (target) { event.preventDefault(); discount(target.dataset.minimalRemoveCode); }
      if (busy && event.target.closest && event.target.closest('[data-item-remove]')) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.matches('[data-minimal-code]')) { event.preventDefault(); discount(); }
    });
    // Verify the authoritative JSON before native checkout. A matching cart does
    // not need another server-rendered drawer; Shopify checkout validates stock.
    var approvedSubmit = false;
    document.addEventListener('submit', async function (event) {
      var form = event.target;
      if (!form.closest('[data-cart]') || !event.submitter || event.submitter.name !== 'checkout' || approvedSubmit || event.defaultPrevented) return;
      event.preventDefault();
      if (busy || !currentCart) return;
      var before = fingerprint(currentCart);
      lock(true); message('busy');
      var changed = false;
      var ok = false;
      try {
        var fresh = await request('cart.js');
        if (!fresh || !Array.isArray(fresh.items) || !Number.isSafeInteger(fresh.item_count) ||
            !Number.isSafeInteger(fresh.total_price) || typeof fresh.currency !== 'string') throw new Error('Invalid cart.');
        changed = before !== fingerprint(fresh) || before !== fingerprint(currentCart);
        ok = changed ? await cart.getCart() : true;
      } catch (error) { ok = false; }
      finally { lock(false); }
      if (!ok || !cart.minimalIsReady()) { message('error'); return; }
      if (changed) { message('cartChanged'); return; }
      message('');
      approvedSubmit = true;
      try { form.requestSubmit(event.submitter); } finally { approvedSubmit = false; }
    });
    function refreshVisible() { if (!busy && !document.hidden && (cart.cartDrawerIsOpen || document.body.classList.contains('template-cart'))) cart.getCart({ reuse: true }); }
    window.addEventListener('pageshow', refreshVisible);
    window.addEventListener('focus', refreshVisible);
    document.addEventListener('visibilitychange', refreshVisible);
    if (channel) channel.onmessage = refreshVisible;
    window.addEventListener('resize', viewport);
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', viewport); window.visualViewport.addEventListener('scroll', viewport); }
    viewport();
  }
  mount();
  document.addEventListener('DOMContentLoaded', mount, { once: true });
})();
